import React from 'react'
import actions from 'redux/actions'

import Text from 'components/_new/typography/Text/Text'
import { Box } from 'components/_new/layout'

import messages from './messages'
import s from './FilterButtons.scss'


const onClick = () => actions.view.smartSearchPage.openFiltersOverlay()


const FilterButtons: React.FunctionComponent = () => (
  <Box className={s.section} mb={24}>
    <div className={s.filterButton} onClick={onClick}>
      <Text
        message={messages.filter}
        size="16-24"
        tag="span"
        color="black"
      />
    </div>
  </Box>
)

export default FilterButtons
